import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { el } from "date-fns/locale";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-inquiry-form",
  templateUrl: "./inquiry-form.component.html",
  styleUrls: ["./inquiry-form.component.scss"],
})
export class InquiryFormComponent implements OnInit {
  @Input() flexFieldData;
  @Input() isFlexfieldEnable;
  @Input() showVideoConf;
  @Input() isEmailFieldRequired;
  @Input() isSubmitted;

  isMobileView: boolean = false;
  isValidName: boolean = false;
  inquiryData = {
    name: "",
    phoneNumber: "",
    email: "",
    description: "",
    videoConf: false,
  };
  // EMAIL_REGEXP =
  //   /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  EMAIL_REGEXP = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,}$/;

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.isMobileView = this.commonService.isMobile();
  }

  ngOnChanges(changes: SimpleChanges) {
    // this.flexFieldData?.forEach((element: any) => {
    //   element.value = null;
    // });
    if (this.showVideoConf == false) {
      delete this.inquiryData.videoConf;
    }
  }

  public changeData(isChecked) {
    if (this.showVideoConf && isChecked) {
      this.isEmailFieldRequired = true;
    }
    if (this.showVideoConf && !isChecked) {
      this.isEmailFieldRequired = false;
    }
  }

  public isValidInquiryData() {
    if (this.isEmailFieldRequired) {
      return (
        this.inquiryData.name?.length > 0 &&
        this.isValidName &&
        this.inquiryData.phoneNumber?.toString()?.length > 9 &&
        this.inquiryData.email?.length > 4 &&
        this.EMAIL_REGEXP.test(this.inquiryData.email)
      );
    } else {
      return (
        this.inquiryData.name?.length > 0 &&
        this.isValidName &&
        this.inquiryData.phoneNumber?.toString()?.length > 9
      );
    }
  }

  public isValidFlexData() {
    if (this.isFlexfieldEnable) {
      let totalFlex = this.flexFieldData?.length
        ? this.flexFieldData.length
        : 0;
      let validFieldCount = 0;
      this.flexFieldData?.forEach((element: any) => {
        if (element.input_type == "Toggle") {
          validFieldCount = validFieldCount + 1;
        } else {
          if (element.required && element.value) {
            validFieldCount = validFieldCount + 1;
          } else if (!element.required) {
            validFieldCount = validFieldCount + 1;
          }
        }
      });
      if (validFieldCount == totalFlex) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  public isValidEmail() {
    return (
      this.inquiryData.email?.length > 4 &&
      this.EMAIL_REGEXP.test(this.inquiryData.email)
    );
  }

  public validateInput(event: any, formError = null) {
    if (formError && formError.errors) {
      this.isValidName = false;
    } else {
      this.isValidName = true;
    }
    // const inputValue = event.target.value.toString().trim();
    // // const alphabeticPattern = /^[a-zA-Z]*$/;
    // const alphabeticPattern = /^[a-zA-Z ]*$/;
    // // const alphabeticPattern = /[a-zA-Z][a-zA-Z ]+/;
    // if (!alphabeticPattern.test(inputValue)) {
    //   // If input value contains non-alphabetic characters, remove them
    //   event.target.value = inputValue.replace(/[^a-zA-Z ]/g, "");
    //   this.inquiryData.name = event.target.value;
    // } else {
    //   this.inquiryData.name = inputValue;
    // }
  }
}
